<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<card>
					<TravelTimeReportTable></TravelTimeReportTable>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import TravelTimeReportTable from '@/components/Report/TravelTimeReportTable.vue';

export default {
	name: 'TravelTimeReport',
	components: {
		TravelTimeReportTable
	}
};
</script>